import { postAlert } from "./quartixApi";

export async function sendRequestDemo(fields, token = null) {
  return postAlert("request_demo", fields, token);
}

export default sendRequestDemo;
